<template>
  <div class="middle-box text-center animated fadeInDown">

    <spinner size="large" message="Saindo"></spinner>

    <div class="image-logo">
      <img src="/static/img/logo-ssparisi.png" alt="Logo">
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Spinner from './layout/Spinner'

export default {
  components: { Spinner },
  methods: {
    ...mapActions(['removeLoggedUser']),

    logout () {
      this.removeLoggedUser({})
      localStorage.removeItem('token')
      this.redirect()
    },

    redirect () {
      const redirectLink = this.$route.query.continue

      if (redirectLink) {
        return window.location.replace(redirectLink)
      }

      return this.$router.push({ path: '/' })
    }
  },

  mounted () {
    this.logout()
  }
}
</script>

<style scoped>
.image-logo {
  width: 400px;
}

.image-logo img {
  max-width: 100%;
}

.spinner {
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/LogoutPage.vue